<template lang="html">
  <v-layout
    v-if="condition"
    align-center
    ma-0
    :mt-2="depth > 0 && index > 0"
  >
    <v-flex
      shrink
      pr-2
      class="font-weight-bold"
    >
      {{ conditionType.toUpperCase() }}
    </v-flex>
    <v-layout ma-0>
      <v-divider
        vertical
        class="mr-2"
      />
      <v-layout
        :column="!inline"
        :row="inline"
        shrink
        ma-0
      >
        <template v-for="(rule, i) in rules">
          <SiConditionChips
            v-if="hasRules(rule)"
            :key="i"
            :condition="rule"
            :inline="inline"
            :depth="depth || 0 + 1"
            :index="i"
          />
          <v-flex
            v-else
            :key="i"
            shrink
            py-1
          >
            <v-chip small>
              <kbd class="mr-2">{{ rule.key }}</kbd>
              <span class="mr-2">{{ rule.operator }}</span>
              <kbd v-if="rule.compare">{{ rule.compareKey }}</kbd>
              <i
                v-else
                class="font-weight-bold"
              >{{ rule.value }}</i>
            </v-chip>
          </v-flex>
        </template>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import conditions from '@/mixins/conditions'

export default {
  mixins: [ conditions ],
  props: {
    condition: Object,
    inline: Boolean,
    index: Number,
    depth: Number
  },
  computed: {
    conditionType () {
      return Object.prototype.hasOwnProperty.call(this.condition, 'all')  ? 'all' : 'any'
    },
    rules () {
      return this.condition[this.conditionType]
    }
  },
  methods: {
    hasRules (rule) {
      return Object.prototype.hasOwnProperty.call(rule, 'all') || Object.prototype.hasOwnProperty.call(rule, 'any') 
    }
  }
}
</script>

<style lang="css" scoped>
</style>
